"use strict";
import { createListenerMiddleware, createSlice } from "@reduxjs/toolkit";
import { shallowEqual } from "react-redux";
import { getHandleOnSetActiveChainId, getHandleOnUpdateDelegatedState } from "state/wallets/effects";
import { InterfaceEventNameLocal } from "features/telemetry/constants";
import { sendAnalyticsEvent } from "features/telemetry/send";
import { InterfaceUserPropertyName, setUserProperty } from "features/telemetry/user";
import { getDevLogger } from "utilities/src/logger/logger";
const initialState = {
  connectedWallets: [],
  switchingChain: false,
  delegatedState: {},
  activeChainId: void 0
};
const walletsSlice = createSlice({
  name: "wallets",
  initialState,
  reducers: {
    setActiveChainId(state, { payload }) {
      state.activeChainId = payload?.chainId;
    },
    addConnectedWallet(state, { payload }) {
      if (state.connectedWallets.some((wallet) => shallowEqual(payload, wallet))) {
        return;
      }
      state.connectedWallets = [...state.connectedWallets, payload];
    },
    startSwitchingChain(state, { payload }) {
      state.switchingChain = payload;
    },
    endSwitchingChain(state) {
      state.switchingChain = false;
    },
    updateDelegatedState(state, { payload }) {
      state.delegatedState = { ...state.delegatedState, [payload.chainId]: payload.address };
    }
  }
});
export const { addConnectedWallet, startSwitchingChain, endSwitchingChain, updateDelegatedState, setActiveChainId } = walletsSlice.actions;
export default walletsSlice.reducer;
export const walletsListenerMiddleware = createListenerMiddleware();
walletsListenerMiddleware.startListening({
  actionCreator: updateDelegatedState,
  effect: (action, { getOriginalState, getState }) => {
    getHandleOnUpdateDelegatedState({
      getOriginalState,
      getState,
      onDelegationDetected: handleDelegationDetected,
      onNewDelegateState: handleNewDelegateState,
      logger: getDevLogger()
    })({ action });
  }
});
walletsListenerMiddleware.startListening({
  actionCreator: setActiveChainId,
  effect: (action, { getState }) => {
    getHandleOnSetActiveChainId({
      getState,
      onDelegationDetected: handleDelegationDetected,
      logger: getDevLogger()
    })({ action });
  }
});
function handleNewDelegateState(input) {
  getDevLogger().info(
    "reducer.ts",
    "handleNewDelegateState",
    `Updating user property for delegated EOA: ${JSON.stringify(Object.keys(input.delegations))}`
  );
  setUserProperty(InterfaceUserPropertyName.IsDelegatedEOA, Object.keys(input.delegations));
}
function handleDelegationDetected(input) {
  getDevLogger().info(
    "reducer.ts",
    "handleDelegationDetected",
    `Sending analytics event for delegation detected: ${JSON.stringify(input)}`
  );
  sendAnalyticsEvent(InterfaceEventNameLocal.DelegationDetected, {
    chainId: input.chainId,
    delegationAddress: input.address,
    isActiveChain: input.isActiveChain
  });
}
